import React, { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import apiService from '../../../services/api';
import { ROUTES } from '../../../utils/constants';
import styles from './VerificationModal.module.css';

const VerificationModal = ({ 
  isOpen, 
  onClose, 
  loginIdentifier, 
  setLoginIdentifier, 
  setCurrentPage 
}) => {
  const { loginWithVerification } = useAuthContext();
  const [verificationCode, setVerificationCode] = useState('');
  const [verifyLoading, setVerifyLoading] = useState(false);

  if (!isOpen) return null;

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (!verificationCode) {
      alert('Please enter the verification code');
      return;
    }

    setVerifyLoading(true);
    const result = await loginWithVerification(loginIdentifier, verificationCode);

    if (result.success) {
      onClose();
      if (result.isAdmin) {
        alert('Welcome Admin! Redirecting to dashboard...');
        setCurrentPage(ROUTES.ADMIN_DASHBOARD);
      } else {
        alert('Logged in successfully!');
      }
    } else {
      alert(result.error);
    }

    setVerifyLoading(false);
  };

  const handleResendCode = async () => {
    try {
      const response = await apiService.sendVerificationCode(loginIdentifier);
      if (response.code) {
        alert(`Verification code resent to ${loginIdentifier}!\n\nFor testing: ${response.code}`);
      } else {
        alert(response.error || 'Failed to resend verification code');
      }
    } catch (error) {
      alert('Network error. Please try again.');
    }
  };

  const handleClose = () => {
    setVerificationCode('');
    onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.verificationModal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={handleClose}>×</button>
        <h2 className={styles.modalTitle}>Verify Your Identity</h2>
        <p className={styles.modalSubtitle}>
          Enter the verification code sent to<br/>
          <strong>{loginIdentifier}</strong>
        </p>
        
        <form onSubmit={handleVerifyCode}>
          <input
            type="text"
            className={`${styles.inputField} ${styles.verificationInput}`}
            placeholder="Enter 6-digit code"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            maxLength="6"
            required
          />
          <button 
            type="submit" 
            className={styles.continueBtn} 
            disabled={verifyLoading}
          >
            {verifyLoading ? 'Verifying...' : 'Verify & Login'}
          </button>
        </form>
        
        <p className={styles.resendText}>
          Didn't receive code? <a href="#" onClick={handleResendCode}>Resend</a>
        </p>
      </div>
    </div>
  );
};

export default VerificationModal;
